export default __webpack_public_path__ + "./fonts/greenCircle.f4fd4e52.svg";